import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, browserHistory } from "react-router";
import classNames from "classnames";

export default class NavigationTab extends Component {
  constructor(props) {
    super(props);

    this.state = { subItemsToggled: false };
    this.toggleSubItems = this.toggleSubItems.bind(this);
  }

  toggleSubItems() {
    this.setState({ subItemsToggled: !this.state.subItemsToggled });
  }

  render() {
    const { to, title, isActive, subItems, onClick } = this.props;
    const { subItemsToggled } = this.state;

    return (
      <li className={classNames("tab-item", { selected: isActive })}>
        {subItems ? null : (
          <Link to={to} onClick={onClick}>
            {title}
          </Link>
        )}
        {subItems && (
          <div className="dropdown">
            <span
              className="dropdown-menu-toggle"
              onClick={this.toggleSubItems}
            >
              {title}
            </span>
            {subItemsToggled && (
              <ul className="dropdown-menu">
                {subItems.map(({ component, url, isActive, onClick }, i) => (
                  <li
                    onClick={onClick || (() => browserHistory.push(url))}
                    key={i}
                    className={classNames("dropdown-item", {
                      selected: isActive,
                    })}
                  >
                    {component}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </li>
    );
  }
}

NavigationTab.propTypes = {
  to: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isActive: PropTypes.bool,
  subItems: PropTypes.array,
  onClick: PropTypes.func,
};
